import React from "react";
import { Link } from "react-router-dom";
import heroSectionImage from "../../../assets/service-hero-image.jpg";
import { Dots } from "react-dot-patterns";

const HeroSection = () => {
  return (
    <div className="active-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>
              Empower Your Workforce
              <br /> with <span>Seamless Payroll</span>
              <br /> Solution
            </h1>
            <p>
              Enhance and optimize your warehouse operations with Cubix, the
              innovative software that simplifies complex processes, boosts
              efficiency, and ensures accuracy across all inventory management
              activities.
            </p>
            <Link to="/contact-us">Book a Demo</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
